import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ============================================================================
// PWA Service Worker registration with safe auto-update flow.
//
// IMPORTANT: a stale Service Worker on Android was serving an OLD bundle.js
// after deploy, which then tried to read tokens from a stale shape and
// rendered "User" / $0 / N/A — making it look like the user was logged into
// another account. This registration now (a) immediately reloads when a new
// SW takes control and (b) actively asks any waiting SW to skip-waiting on
// every page load, so updated code lands on the next refresh — not "some day".
// ============================================================================
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // If a SW is already waiting (new deploy hit us between sessions), ask it to take over.
        if (reg.waiting) {
          try { reg.waiting.postMessage({ type: 'SKIP_WAITING' }); } catch (_) { /* noop */ }
        }
        // When a new SW is found, install it and prompt skip-waiting.
        reg.addEventListener('updatefound', () => {
          const newSW = reg.installing;
          if (!newSW) return;
          newSW.addEventListener('statechange', () => {
            if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
              try { newSW.postMessage({ type: 'SKIP_WAITING' }); } catch (_) { /* noop */ }
            }
          });
        });
      })
      .catch(() => { /* fail silently */ });

    // Reload exactly once when the controlling SW changes (new code is now live).
    let hasReloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hasReloaded) return;
      hasReloaded = true;
      try { window.location.reload(); } catch (_) { /* noop */ }
    });

    // Periodically (every 30 min while the PWA is open) ask the SW to check for an update.
    setInterval(() => {
      navigator.serviceWorker.getRegistration().then((reg) => { if (reg) reg.update().catch(() => {}); });
    }, 30 * 60 * 1000);
  });
}
